import { Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

type Props = {};

@tag("nw-editor-skeleton")
export class NWEditorSkeleton extends Component<Props> {
  static css = [tailwind];

  render() {
    return (
      <div class="animate-fadeInFast px-12">
        {[...Array(4)].map(_ => (
          <div className="animate-pulse space-y-4 w-full">
            <div className="bg-secondary text-3xl rounded-md h-10 mt-10 mb-6"></div>

            {[...Array(4)].map((_, index) => (
              <div key={index} className="h-[1.125rem] bg-secondary rounded-md"></div>
            ))}

            <br />

            <div className="h-48 bg-secondary rounded-md"></div>

            <div className="h-[1.125rem] bg-secondary rounded-md"></div>
            <div className="h-[1.125rem] bg-secondary rounded-md"></div>
          </div>
        ))}
      </div>
    );
  }
}
